module.exports = __webpack_public_path__ + "static/media/color_blind_image_9.cf56401b.jpg";